import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export default function AddToCartDialogSkeletonLoader() {
  return (
    <div className='flex w-full flex-col px-2 md:flex-row md:gap-8 md:px-0'>
      {/* Left side - Image carousel */}
      <aside className='w-full flex-shrink-0 md:w-[50%]'>
        <div className='md:sticky md:top-2'>
          <div className='flex items-start gap-2'>
            {/* Vertical Thumbnail Navigation (Desktop) */}
            <div className='hidden gap-2 overflow-x-hidden overflow-y-auto px-5 py-3 md:flex md:flex-col'>
              {[1, 2, 3, 4].map((_, index) => (
                <Skeleton key={index} className='h-20 w-16 flex-shrink-0 rounded-lg' />
              ))}
            </div>

            {/* Main Image Carousel */}
            <div className='relative w-full overflow-hidden rounded-lg'>
              <Skeleton className='aspect-square w-full rounded-lg' />
            </div>
          </div>
        </div>
      </aside>

      {/* Right side - Product details */}
      <main className='divide-border-title/10 flex-1 divide-y-[1.5px]'>
        <div className='divide-border-title/10 h-fit divide-y-[1.5px]'>
          {/* Product Title, Description, Reviews and Price */}
          <div className='space-y-1 py-4 md:space-y-2 md:pb-4'>
            <Skeleton className='h-6 w-3/4' />
            <Skeleton className='hidden h-16 w-full md:block' />

            {/* Reviews */}
            <div className='flex flex-col gap-1 py-2 md:py-4'>
              <Skeleton className='h-4 w-56' />
              <div className='flex items-center gap-1'>
                <Skeleton className='h-3 w-3' />
                <Skeleton className='h-4 w-64' />
              </div>
            </div>

            {/* Price */}
            <Skeleton className='h-6 w-24' />

            {/* Mobile Description */}
            <div className='block space-y-2 md:hidden'>
              <Skeleton className='h-5 w-40' />
              <Skeleton className='h-20 w-full' />
            </div>
          </div>

          {/* Style Options and Add to Cart */}
          <div className='pb-4'>
            {/* Style Accordion */}
            <Skeleton className='mb-4 h-10 w-full rounded-lg' />

            {/* Quantity and Add to Cart */}
            <div className='flex h-10 items-center gap-4'>
              <Skeleton className='h-full w-32 rounded-full' />
              <Skeleton className='h-full flex-1 rounded-lg' />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
